
const fields = [
		{
			label:'Status',
			name:'status',
			type:'select',
			dataType:'Object',
			readonly:false,
			layout:'col s12 l6',
			values: {},
			options:[
				{
					name: 'Not Started',
					prop: 'not-started',
					id: 22,
				},
				{
					name: 'Pending',
					prop: 'pending',
					id: 23,
				},
				{
					name: 'Complete',
					prop: 'complete',
					id: 24,
				},
				{
					name: 'On-hold',
					prop: 'on-hold',
					id: 25,
				},
				{
					name: 'Unresloved',
					prop: 'unresloved',
					id: 26,
				},
			]
		},
		{
			name:'email',
			label:'Email Address',
			type:'email',
			values:'',
			readonly:false,
			layout:'col s12',
			helperText:{
				d:'Required', s:'Valid', e: 'Valid email address required'
			},
		},
		{
			name:'contact',
			label:'Requesting Party Contact# (xxx xxx xxxx)',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12 l6',
			helperText:{
				d:'Required', s:'Valid', e: 'Enter a valid contact number inluding area code'
			},
		},
		// record starts here
		{
			name:'case_name',
			label:'Case Name',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12'
		},
		{
			name:'name',
			label:'Title',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12'
		},
		{
			name:'case_number',
			label:'Case Number',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12'
		},
		{
			label:'Name of Requesting Party',
			name:'requesting_party',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
		},
		{
			name:'judges',
			label:'Judges',
			type:'content_array',
			single_name:'Judge',
			match: 'judge',
			values:new Object,
			layout:'col s12'
		},
		{
			label:'Name of Transcriptionist',
			name:'transcriptionist',
			type:'select',
			readonly:false,
			dataType:'Object',
			layout:'col s6',
			options:[

				{
					name: 'J&J Court Transcribers',
					prop: 'jj_court_transcribers',
					email: 'jjcourt@jjcourt.com',
					id: 11,
				},
				{
					name: 'Jean Morille',
					prop: 'jean_morille',
					email: 'transcriptsolutionsslu@gmail.com',
					id: 12,
				},
				{
					name: 'Jacqueline Ladoo',
					prop: 'jacqueline_ladoo',
					email: 'jladoo@hotmail.com',
					id: 13,
				},
				{
					name: 'Jean-Marie A. Browne',
					prop: 'jeanmarie_a_browne',
					email: 'jean4reporting@gmail.com',
					id: 14,
				},
				{
					name: 'Verna Monerville',
					prop: 'verna_monerville',
					email: 'verna38monerville@gmail.com',
					id: 15,
				},
				{
					name: 'Yvonne Ratoo',
					prop: 'yvonne_ratoo',
					email: 'vonnie123@hotmail.com',
					id: 16,
				},
				{
					name: 'Internal',
					prop: 'internal',
					email: 'webmaster@eccourts.org',
					id: 17,
				},
			],
			values:new Object,
		},
		{
			label:'Appearances',
			name:'appearances',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
		},
		{
			name:'file_links',
			label:'File Links',
			type:'content_array',
			match: 'url',
			single: 'file',
			values:new Array,
			layout:'col s12 ',
			isMultiple: false,
		},
		{
			name:'request_form',
			label:'Request Form',
			type:'file_upload',
			values:new Object,
			layout:'col s12 ',
			isMultiple: true,
		},
		{
			label:'Names of Legal Practitioners',
			name:'practitioners',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
		},
		{
			label:'Location Where Matter was Heard',
			name:'heard',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
		},
		{
			name:'hearing_dates',
			label:'Date of Trial/Hearing',
			type:'content_array',
			single_name:'Date',
			entryFieldType:'date',
			dataType:'schema',
			match: 'hearing_dates',
			values:new Object,
			layout:'col s12 layout-fix ',
		},
		{
			label:'Turn around time in days',
			name:'turn_around_time',
			type:'number',
			values: '',
			readonly:false,
			layout:'col s6',
		},
		{
			name:'other_attachments',
			label:'Other Attachments',
			type:'file_upload',
			values:[],
			layout:'col s12 ',
			isMultiple: true,
		},
		{
			label:'Comments',
			name:'comments',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
		},
	/* 	{
			name: 'test_options',
			label: 'Testing Options',
			type: 'radio',
			values: new Object,
			layout: 'col s12',
			options: [
				{
					label:'option1',
					value: 'option1'
				},
				{
					label:'option2',
					value: 'option2'
				},
			]
		}, */
		{
			name:'logs',
			label:'Logs',
			match: 'message',
			type:'content_array',
			single_name:'log',
			values:new Object,
			layout:'col s12'
		}
		//end of record
]

const generate = () =>{
	return fields 
}

const populate = (data) => {
	fields.forEach(item => {
		let key = item.name
		let v = data[key]
		
		if (item.dataType === 'Object'){
			v = item.options.find(a => a.prop === v)
		}
	/* 	if(item.name === 'other_attachments') {
			window.console.log(item)
			item.values = data[key].map(x => {return {ID:x.id}})
		}
		else */ if(data[key]) {
			item.values = v
		}
	})
	
	return fields
}


const populateX = (data) => {

let y = fields.map(item => {
		let x = {...item}
		x.values =  data[item.name]
		return x
	})
	return y
}

export default {
	fields, generate, populate, populateX
}